import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { SHARED_API_URL, HTTP_RESPONSE_CODE } from '../../constants/shared/ApiConstants';
import { ENV } from '../../constants/shared/envConstants';
import './ErrorView.scss';

const UNEXPECTED_ERROR_MESSAGE = 
<>
We’re sorry, but an unexpected error occurred. Please try again. If you have questions, please{' '}
<a href="https://service.amplify.com/s/support" target="_blank" rel="noopener noreferrer">contact our support team</a>.
</>
const NO_MAIN_LICENSE_MESSAGE = `You no longer have access to the page you are trying to reach.`;

const buildErrorMessage = error => {
    const errorCode = get(error, 'response.status');
    if (errorCode === HTTP_RESPONSE_CODE.FORDIDDEN) {
        return (
            <>
                {NO_MAIN_LICENSE_MESSAGE}
                <br />
                <a className="redirect-url" href={SHARED_API_URL().BASE_URLS.PORTAL_URL}>
                    Click here to continue
                </a>
            </>
        );
    }
    return (
        <>
            {UNEXPECTED_ERROR_MESSAGE}
            {window.ENV !== ENV.STAGING_ENV && window.ENV !== ENV.PRODUCTION_ENV && (
                <>
                    <br />
                    {get(error, 'response.data') || get(error, 'error.message')}
                </>
            )}
        </>
    );
};

const ErrorView = ({ hasError, error, isDemoModeOn }) =>
    hasError && (
        <div className={`error-panel ${isDemoModeOn ? ' in-demo' : ''}`}>
            {buildErrorMessage(error)}
        </div>
    );

ErrorView.defaultProps = {
    isDemoModeOn: false,
    hasError: false,
    error: {},
};

ErrorView.propTypes = {
    isDemoModeOn: PropTypes.bool,
    hasError: PropTypes.bool,
    error: PropTypes.object,
};

export default ErrorView;
